import React from "react";
function SubmitButtonTwo({ title, className, style,onclick,disabled, ...props }) {
  return (
    <button
      type="submit"
      style={{ textTransform: "none", whiteSpace:"nowrap", ...style }}
      className={`btn login_btn small-text fw-600  m-0 singleLine ${className}`}
      {...props}
      onClick={onclick}
      disabled={disabled}
    >
      {title}
    </button>
  );
}

export default SubmitButtonTwo;
